define([
    "dojo/_base/declare",
    "Apparel/ProductSalesRegionSwitchboard"
], function(declare,ProductSalesRegionSwitchboard) {

    return declare(ProductSalesRegionSwitchboard, {
        switchboardPath: "Child:__Parent__/Child:__Parent__/Child:ProductSalesRegions"
    });
});